export const datatableTheme = {
  row: {
    selectedBackground: "{primary.color}",
    selectedColor: "#ffffff",
  },  
  css: ({ dt }: { dt: (token: string) => string }) => `
  .p-datatable-row-selected a, 
  .p-datatable-row-selected a:hover {
    color: ${dt("datatable.row.selectedColor")};
    text-decoration: underline;
  }
  `
};
